// 导出页面为PDF格式
import html2Canvas from 'html2canvas'
// import JsPDF from 'jspdf'
export default {
  install(Vue, options) {
    Vue.prototype.getPdf = function (title) {
      // var title = title; // pdf名称
      let dom = document.querySelector('#pdfDetail');
      let clonedDom = dom.cloneNode(true); // 克隆 DOM 元素
      let canvasContainer = document.createElement('div');

      // 将克隆的 DOM 添加到临时容器中
      canvasContainer.appendChild(clonedDom);
      document.body.appendChild(canvasContainer);

      html2Canvas(dom, {
        // allowTaint: true,
        useCORS: true, // 允许跨域
        scale: 2,
        dpi: window.devicePixelRatio * 2
      }).then(function (canvas) {
        console.log(canvas.width,canvas.height)
        let contentWidth = canvas.width;
        let contentHeight = canvas.height;
        let pageHeight = contentWidth / 592.28 * 841.89;
        let leftHeight = contentHeight;
        let position = 0;
        //在画布中呈现大小，可调
        let imgWidth = 595.28;
        let imgHeight = 592.28 / contentWidth * contentHeight;
        let pageData = new Image();
        pageData.crossOrigin = 'anonymous';
        pageData.src = canvas.toDataURL('image/jpeg', 1.0);

        let PDF = new jsPDF('', 'pt', 'a4');

        if (leftHeight < pageHeight) {
          PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight);
        } else {
          while (leftHeight > 0) {
            PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight);
            leftHeight -= pageHeight;
            position -= 841.89;
            if (leftHeight > 0) {
              PDF.addPage();
            }
          }
        }
        PDF.save(title + '.pdf');
        document.body.removeChild(canvasContainer); // 移除临时容器
      }).catch(error => {
        console.error("生成PDF时出错:", error);
        document.body.removeChild(canvasContainer); // 移除临时容器
      });
    };
  }
}



// WEBPACK FOOTER //
// ./src/components/utils/htmlToPdf.js